window.BemaltNationalShipping = (() => {
  const normalizeWhatsAppNumber = (value) => String(value || '').replace(/\D/g, '');

  const normalizeOptions = (options) => (Array.isArray(options) ? options : [])
    .map(({ label, value }) => ({ label: String(label || '').trim(), value: String(value || '').trim() }))
    .filter(({ label, value }) => label && value)
    .map(({ label, value }) => `${label}: ${value}`);

  const normalizeQuantity = (value) => {
    const quantity = String(value || '').trim();
    return /^\d+$/.test(quantity) && Number(quantity) > 0 ? quantity : null;
  };

  const productPageUrl = (value, variantId) => {
    try {
      const url = new URL(value || location.pathname, location.origin);
      url.searchParams.delete('variant');
      if (variantId) url.searchParams.set('variant', variantId);
      return url.href;
    } catch {
      return `${location.origin}${location.pathname}`;
    }
  };

  const buildQuoteHref = ({ whatsappNumber, productTitle, productVendor, options, variantId, quantity, productUrl }) => {
    const number = normalizeWhatsAppNumber(whatsappNumber);
    if (!/^\d{8,15}$/.test(number)) return null;

    const confirmedVariantId = String(variantId || '').trim();
    const confirmedQuantity = normalizeQuantity(quantity);
    const message = [
      'Hola, quisiera cotizar el envío nacional de este producto.',
      '',
      `Producto: ${String(productTitle || '').trim()}`,
      String(productVendor || '').trim() ? `Marca: ${String(productVendor).trim()}` : null,
      ...normalizeOptions(options),
      confirmedQuantity ? `Cantidad: ${confirmedQuantity}` : null,
      '',
      'Mi código postal o destino de entrega es:',
      '',
      `Página del producto: ${productPageUrl(productUrl, confirmedVariantId)}`,
    ].filter((line) => line !== null).join('\n');

    return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
  };

  return { buildQuoteHref };
})();
